import React from 'react';
import {
  Nav,
  NavLink,
  Bars,
  NavMenu,
  NavBtn,
  NavBtnLink,
} from './NavbarElements';
  
const Navbar_test = ({toggleSidebar}) => {
  return (
    <>
      <Nav>
  
        <NavMenu>
        <Bars/>
          <NavLink to='/dnd' activeStyle>
            Drag and Drop
          </NavLink>
          <NavLink to='/mc' activeStyle>
            Multiple Choice 
          </NavLink>
          <NavLink to='/videoFlip' activeStyle>
            Video
          </NavLink>

        </NavMenu>
        {
/*

<NavBtn>
          <NavBtnLink to='/'>Sign In</NavBtnLink>
        </NavBtn>
*/
        }
        
      </Nav>
    </>
  );
};
  
export default Navbar_test;